var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.moves.length === 0
    ? _c("div", { staticClass: "pgn-importer" }, [
        _c("textarea", {
          ref: "pgnInput",
          attrs: { placeholder: _vm.placeholderText },
          on: { keyup: _vm.validatePgn }
        }),
        _c(
          "button",
          {
            staticClass: "load-pgn",
            class: [{ invisible: !_vm.showPgnInputButton }],
            on: { click: _vm.loadPgn }
          },
          [_vm._v("Load PGN")]
        ),
        _c(
          "div",
          {
            staticClass: "invalid-pgn",
            class: [{ invisible: !_vm.showError }]
          },
          [_vm._v("Not a valid PGN")]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29aedeed", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29aedeed","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/pgn_importer.vue
// module id = 249
// module chunks = 0